export default __webpack_public_path__ + "static/media/video_3people.61a16761.png";